const pagesSettingsPersonsEn = {
  title: "User Accounts",
  operator: {
    pageTitle: "User Accounts / Operator",
  },
  individual: {
    pageTitle: "User Accounts / Individual",
  },
  // operator(staff) / individual 共通
  account: {
    tabFilterBar: {
      tabs: {
        all: "All",
        inviting: "Inviting",
      },
      actionButtonMenu: {
        invite: "Invite",
        inviteIndividually: "Invite individually",
        inviteGroups: "Invite groups",
      },
      inviteIndividuallyDialog: {
        title: "Invite Individually",
        whoToInvite: "Who to invite",
        whoToInvitePlaceholder: "Type name",
        inviteAs: "Invite as",
        inviteAsTooltip: `In Dress Code, there are two account types: operator and individual.

The operator account is intended mainly for individuals responsible for back-office operations. It can perform operations allowed by assigned roles, granting specific permissions as required.

The individual account is designated for employees and contractors. It allows them to submit applications to their organization and carry out operations relevant to their worker type.

In most cases, users with an operator account also have a individual account.`,
        infoMessage: "The invitation expires in 2 weeks.",
        invite: "Invite",
        cancel: "Cancel",
        membershipType: {
          operator: "Operator",
          individual: "Individual",
        },
        successfulMessage: "Invited successfully",
        inviteCombobox: {
          addPersonToSendInvitation: "Add person",
          duplicateEmail: "Duplicate email",
          internalServerError: "Failed to invite",
        },
      },
      addPersonToSendInvitationDialog: {
        title: "Add person to send invitation",
        workerType: "Worker type",
        workerTypeMasterId: "Worker type master",
        // TODO: common.workerType に統一したい
        employee: "Employee",
        contractor: "Contractor",
        boardMember: "Board Member",
        collaborator: "Collaborator",
        employeeMasterId: "Employment Type",
        contractorMasterId: "Contractor Type",
        collaboratorMasterId: "Collaborator Type",
        boardMemberMasterId: "Board Member Type",
        firstOrGivenName: "First or given name",
        lastNameOrFamilyName: "Last name or family name",
        middleName: "Middle name",
        email: "Email",
        contractFrom: "Contract from",
        addPerson: "Add person",
        cancel: "Cancel",
        optionalLabel: "(Optional)",
        validationErrors: {
          workerType: "Worker type is required",
          workerTypeMasterId: "{{workerTypeMasterId}} is required",
          givenName: "given name is required",
          familyName: "family name is required",
          email: "valid email is required",
          contractFrom: "contract from is required",
          submission: "Registration failed. Please try again.",
        },
      },
    },
    filterBarButtons: {
      freeText: "Filter name...",
      filterChip: {
        status: "Status",
        statusPlaceholder: "Search for status",
      },
    },
    dataTableCard: {
      allActionsColumn: {
        openMenu: "Open menu",
        changeAccountType: "Change account type",
        resetPassword: "Reset password",
        deactivateUser: "Deactivate user",
        deactivateSuccessfulMessage: "Deactivated successfully",
      },
      invitingActionsColumn: {
        openMenu: "Open menu",
        resendInvitation: "Resend invitation",
        copyInvitationLink: "Copy invitation link",
        copiedInvitationLink: "Copied invitation link",
        deleteInvitation: "Delete invitation",
        deletedInvitation: "Deleted invitation",
        resendInvitationDialog: {
          title: "Resend invitation",
          email: "Email",
          resend: "Resend",
          cancel: "Cancel",
          resendInvitationSuccessfulMessage: "Invitation resent successfully",
        },
      },
      personTypeColumn: {
        EMPLOYEE: "Employee",
        BOARD_MEMBER: "Board",
        CONTRACTOR: "Contractor",
        COLLABORATOR: "Collaborator",
      },
      statusColumn: {
        ACTIVE: "Active",
        DEACTIVATED: "Deactivated",
        INVITED: "Invited",
      },
      isExpiredColumn: {
        expired: "Expired",
        notExpired: "Not Expired",
      },
      mfaStatusColumn: {
        enabled: "Enabled",
        notEnabled: "Not Enabled",
      },
    },
  },
};

export default pagesSettingsPersonsEn;
